import React, { useEffect, useState } from "react";
import axios from "axios";
import { FiMapPin, FiBriefcase, FiAlertCircle } from "react-icons/fi";

const DataFetch = ({
  entriesLength,
  setReportDate,
  reportDate,
  section,
  defaultDepart,
  setDefaultDepart,
  setSectionsData,
  setSection,
  machineData,
}) => {
  const urlPrefix2 = process.env.REACT_APP_URL_BLOCK_PREFIX;

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [fetchedData, setFetchedData] = useState([]);

  const fetchData = async () => {
    setLoading(true);
    setError(false);

    try {
      const response = await axios.get(`${urlPrefix2}getstationcode`);

      if (response.data?.status === "ok") {
        setFetchedData(
          Array.isArray(response.data.data) ? response.data.data : [],
        );
      } else {
        setError(true);
      }
    } catch (err) {
      console.error("Failed to fetch stations:", err);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const uniqueSections = [
    ...new Set(fetchedData.map((item) => item.section).filter(Boolean)),
  ];

  useEffect(() => {
    setSectionsData(uniqueSections);
  }, [fetchedData, setSectionsData]);

  const controlStyle = {
    minWidth: "145px",
    maxWidth: "100%",
    fontSize: "12px",
    fontWeight: 600,
    color: "#16365c",
    backgroundColor: "#fff",
    border: "1px solid #dbe5f1",
    borderRadius: "8px",
    minHeight: "36px",
  };

  const labelStyle = {
    fontSize: "11px",
    fontWeight: 700,
    color: "#fff",
    marginBottom: "5px",
    display: "flex",
    alignItems: "center",
    gap: "5px",
  };

  return (
    <div className="w-100">
      <div className="d-flex flex-column flex-sm-row align-items-stretch gap-2">
        {/* Section Selector */}
        <div
          className="rounded-3 p-2 flex-fill d-flex"
          style={{ background: "rgba(255,255,255,0.12)" }}
        >
          <label htmlFor="block-section" style={labelStyle}>
            <FiMapPin size={14} />
            Section
            <span className="me-1" style={{ color: "#ffd166" }}>
              *{" "}
            </span>
          </label>

          <select
            id="block-section"
            className="form-select form-select-sm"
            style={controlStyle}
            value={section || ""}
            onChange={(e) => setSection(e.target.value)}
            disabled={loading}
            required
          >
            <option value="" disabled>
              {loading ? "Loading sections..." : "Select section"}
            </option>

            {uniqueSections.map((sectionName) => (
              <option key={sectionName} value={sectionName}>
                {sectionName}
              </option>
            ))}
          </select>
        </div>

        {/* Department Selector */}
        <div
          className="rounded-3 p-2 flex-fill d-flex"
          style={{ background: "rgba(255,255,255,0.12)" }}
        >
          <label htmlFor="block-department" style={labelStyle}>
            <FiBriefcase size={14} />
            Department{" "}
            <span className="me-1" style={{ color: "#ffd166" }}>
              *
            </span>
          </label>

          <select
            id="block-department"
            className="form-select form-select-sm"
            style={controlStyle}
            value={defaultDepart || ""}
            onChange={(e) => setDefaultDepart(e.target.value)}
            disabled={!machineData?.length}
            required
          >
            <option value="" disabled>
              Select department
            </option>

            {(machineData || []).map((departmentObj, index) => (
              <option
                key={`${departmentObj.DEPARTMENT}-${index}`}
                value={departmentObj.DEPARTMENT}
              >
                {departmentObj.DEPARTMENT}
              </option>
            ))}
          </select>
        </div>
      </div>

      {error && (
        <div
          className="small mt-2 d-flex align-items-center gap-1"
          style={{ color: "#ffe0e0" }}
          role="alert"
        >
          <FiAlertCircle />
          Unable to load section data. Please refresh and try again.
          <button
            type="button"
            className="btn btn-sm btn-light ms-1 py-0"
            onClick={fetchData}
            disabled={loading}
          >
            Retry
          </button>
        </div>
      )}
    </div>
  );
};

export default DataFetch;
